import {useCallback, useEffect, useState} from "react";
import {duplicateSpecificPosition} from "../../../services/company.service";
import {Button, ModalR, RenderDinamicTextInput, RenderTitle, SelectWithCheckboxesAndNestedItems} from "../../common";
import cls from "./RoleInformation.module.scss";
import {CheckIcon, closeIcon, closeIconPurple, questionMarkDark, shredder, successLarge} from "../../../assets/images/new-icons";
import {newPositionName, parentPosition} from "./tooltips";
import MessageContainer from "../../SideMenuEntries/ProcessesComps/MessageContainer/MessageContainer";
import {getErrorMessage} from "../../../shared/utility";

const DuplicatePositionComponent = (comp) => {
    const { isOpen, onClose, positionInfo, multiselectItems } = comp;
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [resultMessage, setResultMessage] = useState('');
    const [selectedParentPosition, setSelectedParentPosition] = useState({
        id: positionInfo.parent_position ? positionInfo.parent_position.id : '',
        label: positionInfo.parent_position ? positionInfo.parent_position.name : '',
        value: positionInfo.parent_position ? positionInfo.parent_position.name : '',
        selected: true,
    });

    const [positionNewName, setPositionNewName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        setErrorMessage('');
    }, [selectedParentPosition]);


    const onDuplicatePressed = () => {
        if (!selectedParentPosition.selected || selectedParentPosition.label === '') {
            setErrorMessage('Make sure to click and select a parent position');
        } else if (selectedParentPosition.label === 'Chairman') {
            setErrorMessage('You cannot duplicate under the Chairman. Select a different parent position');
        } else if (selectedParentPosition.is_department_root === true) {
            setErrorMessage('You cannot duplicate under the departments root position. Select a different parent position');
        } else if (String(positionNewName).trim().length > 0) {
            setLoading(true);
            duplicateSpecificPosition(positionInfo.id, String(positionNewName).trim(), selectedParentPosition.id).subscribe({
                next: () => {
                    setLoading(false);
                    setShowConfirm(true);
                    setResultMessage('Position Has Been Successfully Duplicated.');
                },
                error: (error) => {
                    setLoading(false);
                    setErrorMessage(getErrorMessage(error));
                },
            });
        } else {
            setErrorMessage('Name is required');
        }
    };

    useCallback(() => {
        setLoading(false);
        setShowConfirm(false);
    }, [positionInfo]);

    return (
        <ModalR
            shadowedContainerStyle={{ maxWidth: '600px', minWidth: '475px', width: '475px' }}
            onClose={() => {
                setShowConfirm(false);
                onClose({ cancelled: true });
            }}
            isOpen={isOpen}
            backdropColor={true}
            blured={true}
        >
            <div className={cls.duplicateModalContainer}>
                {!showConfirm ? (
                    <div className={cls.duplicatingPositionContainer}>
                        <div>
                            <img
                                alt={""}
                                src={questionMarkDark}
                                style={{
                                    position: 'absolute',
                                    width: '24px',
                                    height: '24px',
                                    top: '35px',
                                    left: '40px',
                                }}
                            />
                            <div style={{ position: 'absolute', top: '35px', right: '40px' }}>
                                <div
                                    onClick={() => {
                                        onClose({ cancelled: true });
                                    }}
                                    style={{ cursor: 'pointer', backgroundColor: 'transparent', border: 0 }}>
                                    <img alt="" src={closeIcon} style={{ width: '24px', height: '24px' }} />
                                </div>
                            </div>
                            <p className={cls.modalTitle}>
                                Duplicate Position
                            </p>
                        </div>

                        <div className={cls.duplicatingPosition_description}>
                            <RenderTitle title={'Parent Position'}
                                tooltipText={parentPosition} />
                            <div className={cls.duplicatingPosition_parent}>
                                <SelectWithCheckboxesAndNestedItems
                                    hasCloseIcon={false}
                                    noTags={true}
                                    placeholder={'Select Parent Position'}
                                    items={multiselectItems}
                                    groupedBy={'department_name'}
                                    triggerType={'chevron'}
                                    initialSelectedValues={multiselectItems?.filter(i => i.value === positionInfo.parent_id)}
                                    className={cls.peoplePositionsSelect}
                                    inputClassName={cls.peoplePositionsSelectInput}
                                    molclassname={cls.peoplePositionsSelectMenuOverlay}
                                    moliclassname={cls.peoplePositionsSelectMenuOverlayItem}
                                    onChange={(selection) => {
                                        selection?.value &&
                                            setSelectedParentPosition({
                                                id: selection.value,
                                                department_id: selection.department_id,
                                                selected: true,
                                            });
                                    }}
                                    onInputChange={e =>
                                        setSelectedParentPosition({
                                            ...selectedParentPosition,
                                            value: e,
                                            selected: false,
                                        })
                                    }
                                />
                            </div>
                            <RenderTitle title={'Name of The New Position'}
                                tooltipText={newPositionName} />
                            <div className={cls.duplicatingPosition_newName}>
                                <RenderDinamicTextInput
                                    numberOfLines={1}
                                    plcHoffset={'9px'}
                                    maxLength={48}
                                    placeholder="Type here..."
                                    text={positionNewName}
                                    onTextChanged={(text) => {
                                        setErrorMessage('');
                                        setPositionNewName(text);
                                    }}
                                />
                            </div>
                            {errorMessage && <MessageContainer message={errorMessage} />}
                        </div>

                        <div>
                            <Button
                                icon={<CheckIcon style={{ padding: '1px 1px', width: '24px', height: '24px' }} />}
                                title="Complete Duplication"
                                disabled={loading}
                                loading={loading}
                                style={{ marginLeft: '0px', width: '100%', marginTop: '20px', height: '56px' }}
                                titleStyle={{ textAlign: 'center', padding: '0 2px 0 0' }}
                                clicked={onDuplicatePressed}
                            />
                        </div>
                    </div>
                ) : (
                    <div className={cls.duplicatingPosition_resultOperationContainer}>
                        <img src={successLarge} alt="" style={{ padding: '10px 10px', width: '194px', height: '194px' }} />
                        <div className={cls.duplicatingPosition_resultContainer}>
                            <h1 className={cls.duplicatingPosition_resultText}>{resultMessage}</h1>
                        </div>
                        <Button
                            lighter
                            title={'Close'}
                            style={{ width: '122px', height: '56px' }}
                            clicked={() => {
                                onClose({ success: true, message: 'Duplicate Position Has Been Successfully Done.' });
                            }}
                            icon={<img alt="" src={closeIconPurple} />}
                        />
                    </div>
                )}
            </div>
        </ModalR>
    );
};

export default DuplicatePositionComponent;
